import { ContentWrapper } from "~/Components";

function DefaultModule() {
  return <ContentWrapper title={"Module page"}>Default Page</ContentWrapper>;
}

export default DefaultModule;
